/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

// Palette
import palette from 'theme/customColors';

// Material components
import { Box, FormControl, MenuItem, Select, Skeleton } from '@mui/material';

// Shared components
import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletToolbar,
  PortletContent,
} from 'components';

// Component styles
import { useIntl } from 'react-intl';
import { Bar } from 'react-chartjs-2';

export default function TopChart({ title, topChargeInMonth, rateHorary }) {
  const intl = useIntl();
  const [top, setTop] = useState(5);
  const [allGroupNames, setAllGroupNames] = useState([]);

  useEffect(() => {
    const groupNames = topChargeInMonth.map((item) => item.charge.name);
    setAllGroupNames(groupNames);
  }, [topChargeInMonth]);

  const filteredGroupName = allGroupNames.slice(0, top);

  const baseKWh = topChargeInMonth
    .slice(0, top)
    .map((item) => item.charge.consumes[1][2]);
  const mediaKWh = topChargeInMonth
    .slice(0, top)
    .map((item) => item.charge.consumes[1][2]);
  const puntaKWh = topChargeInMonth
    .slice(0, top)
    .map((item) => item.charge.consumes[1][3]);

  const totalConsumation = topChargeInMonth.map((item) =>
    item.total_consumption.toFixed(2)
  );

  const handlerTop = (e) => {
    e.preventDefault();
    setTop(e.target.value);
  };

  const dateSetsOptions =
    rateHorary === 1
      ? [
          {
            label: intl.formatMessage({
              id: 'app.meter.board.topCharges.offkWh',
            }),
            yAxisID: 'A',
            backgroundColor: '#3A5F0B',
            data: baseKWh,
            borderRadius: 10,
          },
          {
            label: intl.formatMessage({
              id: 'app.meter.board.topCharges.midkWh',
            }),
            yAxisID: 'A',
            backgroundColor: '#FFCC00',
            data: mediaKWh,
            borderRadius: 10,
          },
          {
            label: intl.formatMessage({
              id: 'app.meter.board.topCharges.onkWh',
            }),
            yAxisID: 'A',
            backgroundColor: 'red',
            data: puntaKWh,
            borderRadius: 10,
          },
        ]
      : [
          {
            label: intl.formatMessage({
              id: 'app.charge.board.mainHead.consumtion',
            }),
            yAxisID: 'A',
            backgroundColor: '#45B880',
            data: totalConsumation,
            borderRadius: 10,
          },
        ];

  const data = {
    labels: filteredGroupName,
    datasets: dateSetsOptions,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: true },
    cornerRadius: 20,
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
      borderColor: palette.border,
      backgroundColor: palette.common.white,
      titleFontColor: palette.text.primary,
      bodyFontColor: palette.text.secondary,
      footerFontColor: palette.text.secondary,
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          let value = tooltipItem.raw; // Usar 'raw' en lugar de 'value'
          label += `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} kWh`;
          return label;
        },
      },
    },
    layout: { padding: 0 },
    scales: {
      x: {
        barPercentage: 0.9,
        categoryPercentage: 0.8,
        ticks: {
          font: {
            family: 'Roboto', // Asegúrate de que tienes la fuente adecuada
          },
          color: palette.text.secondary,
          padding: 20,
        },
        grid: {
          // Cambié gridLines a grid
          display: false,
          drawBorder: false,
        },
      },
    },
  };

  return (
    <Portlet>
      <PortletHeader noDivider>
        {title ? (
          <PortletLabel title={title} />
        ) : (
          <Skeleton variant="text" width={200} height={50} />
        )}
        {allGroupNames.length > 3 && (
          <PortletToolbar>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Select
                displayEmpty
                inputProps={{ 'aria-label': 'Select Top' }}
                onChange={handlerTop}
                value={top}
                sx={{ mt: 3 }}
              >
                <MenuItem value={3}>
                  {intl.formatMessage({
                    id: 'app.meter.board.topCharges.top3',
                  })}
                </MenuItem>
                <MenuItem value={5}>
                  {intl.formatMessage({
                    id: 'app.meter.board.topCharges.top5',
                  })}
                </MenuItem>
                {allGroupNames.length > 5 && (
                  <MenuItem value={10}>
                    {intl.formatMessage({
                      id: 'app.meter.board.topCharges.top10',
                    })}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </PortletToolbar>
        )}
      </PortletHeader>
      <PortletContent>
        <Box height={400} position="relative">
          <Bar data={data} options={options} />
        </Box>
      </PortletContent>
    </Portlet>
  );
}
